module.exports = __webpack_public_path__ + "media/images/logo-icon-red-544864814ba33c4a443d2978e8b5c344.svg";